<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane
                label="视频资源"
                name="1"
                link="/operation/video/list"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/video/task/list')"
                label="待转码视频"
                name="2"
                link="/operation/video/task"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/channel/list')"
                label="频道管理"
                name="3"
                link="/operation/video/channel/list"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/paid/list')"
                label="付费策略"
                name="4"
                link="/operation/video/strategy"
            ></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: "1",
        },
    },
    data() {
        return {
            activeName: this.name
        };
    },
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>